import { Card, CardContent, Typography, Box} from "@mui/material";
import TaskAltIcon from '@mui/icons-material/TaskAlt';



function Success() {
    return ( <>
        <Card>
            <CardContent>
                <Box display='flex' columnGap={2}>
                    <TaskAltIcon color="success" fontSize="large"/>
                    <Typography variant={'h5'} color = 'success'>
                        Success
                    </Typography>
                </Box>
                
            </CardContent>
        </Card>
    </> );
}

export default Success;